/*
 * esFormLegendController
 * */

class EsFormLegendController {
	constructor($log) {
		'ngInject';
		this.$log = $log;
	}

	$onInit() {
		this.$log = this.$log.getInstance('EsFormLegendController');
		this.$log.debug('loaded');
	}
}

export default EsFormLegendController;
